import { Link } from "react-router"

export const OrderOnlineLink = ({
  shopper_short_key,
}: {
  shopper_short_key: string
}) => {
  return (
    <Link
      to={`${import.meta.env.VITE_CUST_SITE}/join/${shopper_short_key}`}
      target="_blank"
    >
      <span className="tw:text-sm">{`Continue Order Online: ${import.meta.env.VITE_CUST_SITE}/join/${shopper_short_key}`}</span>
    </Link>
  )
}
